/** La papelera: lo borrado se puede devolver, y sólo administración lo borra para siempre. */
import { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { ErrorDeApi, api } from '../api'
import { Dialogo, Vacio } from '../componentes/piezas'
import { usePortal } from '../contexto'
import { hace } from '../textos'
import { IconoDePagina } from './Arbol'
import { useEspacio } from './contexto'
import type { EnPapelera, Pagina } from './tipos'

export default function Papelera() {
  const { servidor, puedo, avisar } = usePortal()
  const { rutaPaginas, abrirPapelera, recargar } = useEspacio()
  const navegar = useNavigate()
  const [lista, setLista] = useState<EnPapelera[] | null>(null)
  const [confirmando, setConfirmando] = useState<number | null>(null)

  const cargar = useCallback(async () => {
    try {
      setLista(await api.get<EnPapelera[]>(`${rutaPaginas}/papelera`))
    } catch (e) {
      avisar(e instanceof ErrorDeApi ? e.message : 'No se ha podido abrir la papelera.', 'malo')
      setLista([])
    }
  }, [rutaPaginas, avisar])

  useEffect(() => {
    void cargar()
  }, [cargar])

  const restaurar = async (id: number) => {
    try {
      const pagina = await api.post<Pagina>(`${rutaPaginas}/${id}/restaurar`)
      await recargar()
      abrirPapelera(false)
      navegar(`/${servidor.id}/paginas/${pagina.id}`)
    } catch (e) {
      avisar(e instanceof ErrorDeApi ? e.message : 'No se ha podido restaurar.', 'malo')
    }
  }

  const borrar = async (id: number) => {
    try {
      await api.borrar(`${rutaPaginas}/${id}/definitivo`)
      setConfirmando(null)
      await cargar()
    } catch (e) {
      avisar(e instanceof ErrorDeApi ? e.message : 'No se ha podido borrar.', 'malo')
    }
  }

  return (
    <Dialogo titulo="Papelera" alCerrar={() => abrirPapelera(false)}>
      {lista === null && <p className="cargando">Cargando…</p>}
      {lista?.length === 0 && (
        <Vacio titulo="La papelera está vacía">
          <p>Lo que borres aparecerá aquí y podrás recuperarlo.</p>
        </Vacio>
      )}
      <ul className="lista papelera">
        {lista?.map((p) => (
          <li key={p.id} className="fila">
            <IconoDePagina icono={p.icon} />
            <div className="fila__principal">
              <div className="fila__titulo">{p.title || 'Sin título'}</div>
              <div className="fila__meta">borrada {hace(p.deleted_at)}</div>
            </div>
            {confirmando === p.id ? (
              <>
                <button className="boton boton--malo" onClick={() => void borrar(p.id)}>
                  Borrar para siempre
                </button>
                <button className="boton boton--plano" onClick={() => setConfirmando(null)}>
                  No
                </button>
              </>
            ) : (
              <>
                {puedo('editar_paginas') && (
                  <button className="boton" onClick={() => void restaurar(p.id)}>
                    Restaurar
                  </button>
                )}
                {puedo('vaciar_papelera') && (
                  <button className="boton boton--plano" onClick={() => setConfirmando(p.id)}
                          aria-label="Borrar para siempre">
                    🗑
                  </button>
                )}
              </>
            )}
          </li>
        ))}
      </ul>
    </Dialogo>
  )
}
